import { useContext } from 'react'

import { InternationalizationContext } from './Provider'

export const useIntl = () => useContext(InternationalizationContext)
